
(function(window, document, $, undefined) {

    'use strict';
    window.animations = {};

    animations.init = function () {

       // animations.mobileMenuToggle();
        animations.navMenuZindexFix();
    }

    animations.navMenuZindexFix = function() {

        let $menuItem = $('body:not(.home) .menu-primary');
        let $container = $('header.site-header');

        $menuItem.hover(
            function(){
                gsap.to( $container, { zIndex: 9999}, 0);
            },
            function(){
                gsap.to( $container, { zIndex: 2000}, 0);
            })

    }

    animations.mobileMenuToggle = function() {



    }


    $(document).on( 'ready', animations.init );

})(window, document, jQuery);